import { useAuthCallback } from '../hooks/useAuth.js';

export function AuthCallback() {
  const { error } = useAuthCallback();
  if (error)
    return (
      <div className="flex h-screen items-center justify-center text-xd-error">
        Auth error: {error}
      </div>
    );
  return (
    <div className="flex h-screen items-center justify-center text-text">Iniciando sesión...</div>
  );
}
